import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "row my-2" }
const _hoisted_3 = { class: "container col-sm col-md-8" }
const _hoisted_4 = { class: "row justify-content-end mt-2" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "col summary-col align-self-center" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "col summary-col align-self-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      here: '差分概要（全体）',
      ancestries: _ctx.ancestries
    }, null, 8, ["ancestries"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "col h2",
        style: _normalizeStyle({ fontSize: _ctx.FontSizes.large2})
      }, "支店ごとの配布記録データ差分概要", 4)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, "更新日時：" + _toDisplayString(_ctx.updatedDTString()), 1)
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row table-header-row" }, [
          _createElementVNode("div", { class: "col" }, "支店名"),
          _createElementVNode("div", { class: "col" }, "差分概要")
        ], -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordDiffSummary.entities, (bEntity) => {
          return (_openBlock(), _createElementBlock("div", {
            key: bEntity.vForKey,
            class: "row summary-row"
          }, [
            _createElementVNode("div", _hoisted_6, [
              (bEntity.hasDiff)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _withModifiers(($event: any) => (_ctx.onClickBranchSummary(bEntity.branch)), ["prevent"]),
                    href: "#"
                  }, _toDisplayString(bEntity.branch), 9, _hoisted_7))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(bEntity.branch), 1)
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", {
                class: _normalizeClass(["diff-text", {'added': bEntity.added > 0}])
              }, "追加：" + _toDisplayString(bEntity.added), 3),
              _createElementVNode("p", {
                class: _normalizeClass(["diff-text", {'changed': bEntity.changed > 0}])
              }, "変更：" + _toDisplayString(bEntity.changed), 3),
              _createElementVNode("p", {
                class: _normalizeClass(["diff-text", {'deleted': bEntity.deleted > 0}])
              }, "削除：" + _toDisplayString(bEntity.deleted), 3)
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}